var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./WarehouseShopItem.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-a1976156!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./WarehouseShopItem.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Warehouse/WarehouseShopItem.vue
// module id = 661
// module chunks = 0